<template>
  <div class="w-100">
    <div class="chat-content chat-bot info-right container-card-request">
      <div class="p-1">
        <h5>{{  $t('creator.askCreator') }}</h5>
        <span class="text-muted">{{  $t('creator.haveDoubts') }}</span>

        <b-form-group class="mt-2" v-slot="{ ariaDescribedby }">
          <b-form-radio class="mt-1" v-model="reason" :aria-describedby="ariaDescribedby" name="some-radios" :value="$t('creator.negotiableDetails')">{{  $t('creator.negotiableDetails') }}</b-form-radio>
          <b-form-radio class="mt-1" v-model="reason" :aria-describedby="ariaDescribedby" name="some-radios" :value="$t('creator.collaborationPreferences')">{{  $t('creator.collaborationPreferences') }}</b-form-radio>
          <b-form-radio class="mt-1" v-model="reason" :aria-describedby="ariaDescribedby" name="some-radios" :value="$t('creator.interestedCollaboratingCampaigns')">{{  $t('creator.interestedCollaboratingCampaigns') }}</b-form-radio>
        </b-form-group>
        
        <div class="mt-1">
          <b-button @click="submitRequestPrice()" variant="info" :disabled="reason === ''">{{ $t('creator.submit') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BFormGroup,
  BFormRadio
} from 'bootstrap-vue'
import chat_service from '@/services/chat';

export default {
  name: 'requestPrice',
  components: {
    BButton,
    BFormGroup,
    BFormRadio
  },
  props: {
    chat: {
      type: Object,
      required: true,
    },
    is_legacy: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      reason: ''
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
    submitRequestPrice() {
      const message = this.reason
      const service = this.is_legacy ? chat_service.priceRequest : chat_service.sendMessageTextV4

      service(this.chat.uuid, message).then(() => this.$emit('update_chat'))
    }
  },
  watch: {
  }
}
</script>

<style>
.check-position {
  position: absolute;
  left: 60px;
}
.box-info {
  width: 100%;
  max-width: 95% !important;
  color: #ADB0B4 !important;
  background-color: #F7F9FB !important;
  border: 2px solid #c8c8c8;
  padding: 5px;
}
.text-box-success {
  color: #506263;
}
.box-success {
  width: 100%;
  max-width: 95% !important;
  color: #4E5B5B !important;
  background-color: #DDF8EE !important;
  border: 2px solid #A9D7C9;
}
.info-right {
  border-left: 7px solid #55A6C4;
  background: white;
}
.container-card-request {
  border: 1px solid #c8c8c8;
  border-radius: 8px;
}
</style>
